import { createContext, useMemo, useState, type PropsWithChildren } from 'react';

type Theme = 'dark';

type ThemeContextValue = {
  theme: Theme;
  accentColor: string;
  setTheme: (theme: Theme) => void;
};

export const ThemeContext = createContext<ThemeContextValue | null>(null);

export function ThemeProvider({ children }: PropsWithChildren) {
  const [theme, setTheme] = useState<Theme>('dark');

  const value = useMemo(
    () => ({
      theme,
      accentColor: '#FFC107',
      setTheme
    }),
    [theme]
  );

  return <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>;
}
